<template>
  <q-card style="min-width: 400px">
    <q-card-section class="row items-center text-h6">
      Ta bort avställning
    </q-card-section>
    <q-card-section>
      <p>Är du säker på att du vill ta bort avställningen?</p>
    </q-card-section>
    <q-card-actions align="right">
      <q-btn
        flat
        label="Avbryt"
        @click="deleteModal.closeModal"
        type="button"
        :disable="loading.delete"
      />
      <q-btn
        label="Ta bort"
        type="button"
        color="red"
        :loading="loading.delete"
        @click="onConfirm"
      />
    </q-card-actions>
  </q-card>
</template>

<script lang="ts">
import { UseModal } from '@/composable/useModal'
import { useVehicleWithdrawal } from '@/composable/useVehicleWithdrawal'
import { defineComponent, inject } from 'vue'

export default defineComponent({
  name: 'VehicleWithdrawalDeleteModal',

  setup() {
    const { loading, remove } = useVehicleWithdrawal()

    const deleteModal = inject<UseModal<{ uuid: string }>>('delete-modal')

    function onConfirm() {
      if (!deleteModal?.state.data) {
        throw new Error('Ingen uuid i deleteModal data parametrar')
      }

      remove(deleteModal.state.data.uuid)

      deleteModal.closeModal()
    }

    return {
      deleteModal,
      loading,
      onConfirm,
    }
  },
})
</script>
